import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Logo, Empty } from "@/lib/ui";

export default function BuyerCity() {
  const nav = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/public/active-cities").then(({ data }) => setData(data)).catch(() => setData({ cities: [], pan_india_count: 0 }));
  }, []);

  const go = (city) => nav(city ? `/marketplace?city=${encodeURIComponent(city)}` : "/marketplace");

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <header className="flex items-center justify-between px-6 py-5 sm:px-10">
        <button onClick={() => nav("/")}><Logo dark /></button>
        <button onClick={() => go("")} data-testid="browse-all-link" className="text-xs font-semibold uppercase tracking-wider text-slate-400 hover:text-orange-400">
          Browse all →
        </button>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-6">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-orange-500">Step 2 of 2</p>
        <h1 className="mt-2 font-head text-3xl font-extrabold sm:text-4xl">What city are you buying in?</h1>
        <p className="mt-2 text-sm text-slate-400">Pick a city with live stock. Pan-India listings show everywhere.</p>

        {!data ? (
          <p className="mt-8 text-slate-500">Loading cities…</p>
        ) : data.cities.length === 0 ? (
          <div className="mt-8"><Empty text="No active listings yet — browse all stock" icon="fa-city" /></div>
        ) : (
          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3">
            {data.pan_india_count > 0 && (
              <button
                onClick={() => go("")}
                data-testid="city-panindia"
                className="group rounded-2xl border border-orange-500/40 bg-orange-500/10 p-5 text-left transition hover:-translate-y-0.5 hover:bg-orange-500/20"
              >
                <i className="fa-solid fa-truck-fast mb-2 block text-xl text-orange-400" />
                <p className="font-head text-lg font-bold">All India</p>
                <p className="text-xs text-slate-300">{data.pan_india_count} pan-India listings</p>
              </button>
            )}
            {data.cities.map((c) => (
              <button
                key={c.city}
                onClick={() => go(c.city)}
                data-testid={`city-${c.city}`}
                className="group rounded-2xl border border-white/10 bg-white/5 p-5 text-left transition hover:-translate-y-0.5 hover:border-orange-500 hover:bg-white/10"
              >
                <i className="fa-solid fa-location-dot mb-2 block text-xl text-orange-400" />
                <p className="font-head text-lg font-bold">{c.city}</p>
                <p className="text-xs text-slate-400">{c.count} live listing{c.count > 1 ? "s" : ""}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-orange-400">
                  View stock <i className="fa-solid fa-arrow-right transition group-hover:translate-x-1" />
                </span>
              </button>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
